import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { User, LogOut, LogIn } from "lucide-react";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import "./AdminHeader.css";

const COPY = {
  fallbackName: "Admin",
  logout: "Logout",
  login: "Login",
  confirmLogout: "Are you sure you want to logout?",
  confirmButton: "Yes, logout",
};

const AdminHeader = () => {
  const navigate = useNavigate();
  const [loggedIn] = useState(localStorage.getItem("admin"));
  // Sessions that signed in before the email was stored fall back to the name.
  const displayName =
    localStorage.getItem("adminEmail") || loggedIn || COPY.fallbackName;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Expired tokens leave the UI looking logged in while every request 401s,
  // so kick the session out as soon as the clock passes exp.
  useEffect(() => {
    const checkTokenExpiry = () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const { exp } = jwtDecode(token);
        if (exp < Math.floor(Date.now() / 1000)) {
          localStorage.removeItem("admin");
          navigate("/admin");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    };

    const interval = setInterval(checkTokenExpiry, 60000);
    return () => clearInterval(interval);
  }, [navigate]);

  const handleLogout = () => {
    Swal.fire({
      title: "",
      text: COPY.confirmLogout,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: COPY.confirmButton,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("admin");
        localStorage.removeItem("adminEmail");
        localStorage.removeItem("token");
        navigate("/admin");
      }
    });
  };

  return (
    <header className="admin-header">
      <div className="relative" ref={menuRef}>
        <button
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          className="admin-header-user"
        >
          <span>{displayName}</span>
          <span className="admin-header-avatar">
            <User size={16} strokeWidth={2.5} />
          </span>
        </button>

        {menuOpen && (
          <div className="admin-header-menu">
            {loggedIn ? (
              <button type="button" onClick={handleLogout}>
                <LogOut size={16} />
                {COPY.logout}
              </button>
            ) : (
              <button type="button" onClick={() => navigate("/admin")}>
                <LogIn size={16} />
                {COPY.login}
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default AdminHeader;
